import type { ComponentType, SVGProps } from 'react'
import {
    CollectionIcon,
    FolderIcon,
    GlobeIcon,
    MusicLibraryIcon,
    SettingsIcon,
    StatisticsIcon,
} from '@ds/components'
import { type TTranslationKey } from '../constants/navigation'
import { type TUserMenuEventName } from './navAnalytics'
import { ROUTES } from '../constants/routes'
import { getUserRoutes } from './routes'

export type TUserMenuItem = {
    labelKey: TTranslationKey
    href: string
    Icon: ComponentType<SVGProps<SVGSVGElement>>
    analytics?: TUserMenuEventName
}

export const getUserMenuItems = (username: string) => {
    const routes = getUserRoutes(username)

    return [
        { labelKey: 'i18n.headerMyAudio', href: routes.audio, Icon: MusicLibraryIcon },
        { labelKey: 'i18n.headerCollections', href: routes.collections, Icon: CollectionIcon },
        { labelKey: 'i18n.headerProjects', href: routes.projects, Icon: FolderIcon },
        { labelKey: 'i18n.headerPromoPages', href: routes.promoPages, Icon: GlobeIcon },
        {
            labelKey: 'i18n.commonAnalytics',
            href: routes.insights,
            Icon: StatisticsIcon,
            analytics: 'menu_insights_click',
        },
        { labelKey: 'i18n.headerSettings', href: ROUTES.settings, Icon: SettingsIcon },
    ] satisfies TUserMenuItem[]
}
